import Reveal from "@/components/Reveal";

const INCENTIVES = [
  {
    name: "Federal investment tax credit",
    value: "May apply to business owners",
    detail:
      "A dollar-for-dollar credit against federal tax liability. Confirm the current rate and your eligibility with your CPA.",
  },
  {
    name: "MACRS depreciation",
    value: "May apply to business owners",
    detail:
      "Solar equipment sits in the five-year property class. Your CPA confirms the depreciable basis and schedule.",
  },
  {
    name: "Loan interest",
    value: "100% deductible",
    detail: "If financed, interest is generally a deductible business expense.",
  },
];

const LICENSES = [
  ["FL Certified Roofing Contractor", "License CCC1335978", null],
  ["FL Certified Electrical Contractor", "License EC13013993", null],
  ["Tesla Certified Installer", "Powerwall · Solar Roof · Solar Panels · EV Charging", null],
  ["GAF Certified", "Certified Roofing Contractor · GAF Energy Solar Certified", null],
  ["Veteran Owned", "Led by those who have served", null],
  ["Since 2019", "1,000+ systems installed · BBB A+ accredited", null],
];

export default function IncentivesLicenses() {
  return (
    <section className="section inc" id="incentives" data-testid="incentives-licenses">
      <div className="wrap">
        <div className="section-heading">
          <div>
            <span className="eyebrow">INCENTIVES &amp; CREDENTIALS</span>
            <h2>
              Your incentives,
              <br />
              on the table.
            </h2>
          </div>
          <p>Informational only — not tax advice. Your CPA confirms eligibility, rates and timing for every line below.</p>
        </div>
        <Reveal>
          <div className="inc-wrap">
            <table className="inc-table" data-testid="incentives-table">
              <thead>
                <tr>
                  <th scope="col">Incentive</th>
                  <th scope="col">Value</th>
                  <th scope="col">Detail</th>
                </tr>
              </thead>
              <tbody>
                {INCENTIVES.map((row) => (
                  <tr key={row.name}>
                    <td data-label="INCENTIVE">
                      <b>{row.name}</b>
                    </td>
                    <td data-label="VALUE">
                      <span className="inc-tag">{row.value}</span>
                    </td>
                    <td data-label="DETAIL">{row.detail}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </Reveal>
        <Reveal delay={0.08}>
          <div className="lic-grid" data-testid="license-grid">
            {LICENSES.map(([title, sub, href], i) => (
              <div className="lic-card" key={title} data-testid={`license-item-${i + 1}`}>
                {href ? (
                  <a href={href} target="_blank" rel="noreferrer">
                    {title} <span>↗</span>
                  </a>
                ) : (
                  <b>{title}</b>
                )}
                <span>{sub}</span>
              </div>
            ))}
          </div>
          <p className="micro">
            Florida licenses CCC1335978 (roofing) and EC13013993 (electrical) open as official PDF records. Solar Black Belt is a
            Coastal Energy project — commercial solar, storage and roofing installed by licensed Florida crews.
          </p>
        </Reveal>
      </div>
    </section>
  );
}
